import React from 'react';

export default function LoanOfficerCard({ loanOfficer }) {
    if (!loanOfficer.vanityURL) {
        return null;
    }

    const cardClass = `loan-officer-card${loanOfficer.isPresidentsClub ? ' is-presidents-club' : ''}`;

    return (
        <a href={`/${loanOfficer.vanityURL}`} className={cardClass}>
            <div className="image-container">
                <img src={loanOfficer.photoURL} alt={`${loanOfficer.name}'s photo`} />
            </div>
            <div className="content-container">
                <h3 className="name">{loanOfficer.name}</h3>
                {loanOfficer.clubDesignation && <h4 className="presidents-club">{loanOfficer.clubDesignation}</h4>}
                <div className="title-container">
                    {loanOfficer.title}, NMLS #{loanOfficer.NmlS_Number}
                </div>
            </div>
        </a>
    );
};
